import { Link } from "react-router-dom";
import { SELLER } from "@/config/legal";

const links = [
  { to: "/pricing", label: "Pricing" },
  { to: "/terms-of-use", label: "Terms & Conditions" },
  { to: "/privacy-policy", label: "Privacy Notice" },
  { to: "/refund-policy", label: "Refund Policy" },
];

export const Footer = () => (
  <footer className="border-t bg-background mt-auto">
    <div className="container mx-auto px-4 py-6">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="text-sm text-muted-foreground">
          © 2026 {SELLER.legalName} ({SELLER.tradingName}). All rights reserved.
        </div>
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="text-muted-foreground hover:text-primary transition-colors">
              {l.label}
            </Link>
          ))}
          <a href={`mailto:${SELLER.supportEmail}`} className="text-muted-foreground hover:text-primary transition-colors">
            Contact
          </a>
        </div>
      </div>
    </div>
  </footer>
);
